export default class Questionnaire {
    static init() {
        if (document.querySelector('body').classList.contains('neos-backend')) {
            return;
        }

        Array.prototype.forEach.call(document.querySelectorAll('.questionnaire-component'), el => {
            new Questionnaire(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        this.options = element.querySelectorAll('.multi-survey__option');

        const hasLiked = element.querySelector('.multi-survey__option[data-liked]');
        if (hasLiked) {
            this.showResult();
            return;
        }

        /*
        this.options.forEach((el) => {
            el.innerHTML = el.dataset.label

            el.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                // use Google Recaptcha to recognize the user
                const likeButton = e.target;
                likeButton.disabled = true;
                this.onGrecaptchaReady(likeButton);
            })
        })
        */
        element.addEventListener('click', (e) => {
            const likeButton = e.target ? e.target.closest('.multi-survey__option') : null;
            if(!likeButton) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();

            // use Google Recaptcha to recognize the user
            likeButton.disabled = true;
            this.onGrecaptchaReady(likeButton);
        })
    }

    onGrecaptchaReady(likeButton) {
		if (!window.grecaptcha) {
			window.alert('Du musst zuerst Cookies akzeptieren bevor du diese Funktion verwenden kannst!');
			return;
		}

        const websiteKey = document.body.dataset.recaptchaWebsiteKey;
        if (!websiteKey) {
			window.alert('Missing Recaptcha configuration');
        }

        if (document.body.dataset.isLoggedIn === undefined) {
            /* global grecaptcha */
            grecaptcha.execute(websiteKey, {action: 'like'}).then((reCaptchaToken) => {
                console.info('recaptcha based login successful');
                this.performLike(likeButton, reCaptchaToken);
            });
        } else {
            this.performLike(likeButton, null)
        }
    }

    performLike(likeButton, reCaptchaToken) {
        this.disablePage();
        // see LikesButton.js
        let endpoint = "/likes/addLike";
        likeButton.dataset.liked = true;
        likeButton.dataset.likesCount = likeButton.dataset.likesCount * 1 + 1;

        // likeButton.innerHTML = likeButton.dataset.likesCount;
        let data = new URLSearchParams();
        data.set('subjectId', likeButton.dataset.subjectId);
        if (reCaptchaToken) {
            data.set('reCaptchaToken', reCaptchaToken);
        }

        fetch(endpoint, {
            method: 'POST',
            credentials: 'include',
            body: data
        })
            .then(() => {
                document.body.dataset.isLoggedIn = true;
                likeButton.disabled = false;
                console.info('Option click saved successful');
                // directly update the visual part
                this.showResult();
                this.enablePage();
            })
            .catch(() => {
                console.error('Something went wrong while trying to vote');
                likeButton.disabled = false;
            });
    }

    showResult() {
        let element = this.element;
        let resultInfo = Array.from(element.querySelectorAll('.questionnaire-component__result-text'));

        resultInfo.forEach((el) => {
            el.classList.remove('hidden')
        });

        // calculate percentage
        let reducer = (carry, el) => carry + parseInt(el.dataset.likesCount);
        let sum = Array.prototype.reduce.call(this.options, reducer, 0);

        this.options.forEach((el) => {
            el.classList.add('result-bar')
            let percentageElement = el.querySelector('.multi-survey__option-percentage');
            let labelElement = el.querySelector('.multi-survey__option-label');
            let circleElement = el.querySelector('.multi-survey__option-circle');
            let percentage = Math.round(el.dataset.likesCount / sum * 100);
            let isLabelFit = percentage >= 30;
            circleElement.classList.add('hidden');
            percentageElement.style.minWidth = `${percentage/2}%`;
            el.dataset.percentage = percentage.toString();
            percentageElement.innerHTML = isLabelFit ? `${percentage}%` : ``;
            labelElement.innerHTML = isLabelFit ? el.dataset.label : `${el.dataset.label} (${percentage}%)`;
            el.classList.add('is-disabled');
        });
    }

    disablePage() {
        document.body.classList.add('pointer-events-none');
        document.body.classList.add('overflow-hidden');
        document.body.classList.add('opacity-60')
    }

    enablePage() {
        document.body.classList.remove('pointer-events-none');
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('opacity-60')
    }
}
